module.exports = __webpack_public_path__ + "static/img/bg-fr.a6c3e106.png";